<template>
  <div class="my_record">
    <van-nav-bar
      title="我的打卡"
      left-text=""
      right-text=""
      left-arrow
      @click-left="back"
    />

    <div class="stat_panel bgwhite" v-if="stat">
      <div class="item">
        <div class="value">{{stat.user_stat.distance}}<span class="unit">公里</span></div>
        <div class="label">累计跑量</div>
      </div>
      <div class="item">
        <div class="value">{{stat.user_stat.run_num}}<span class="unit">次</span></div>
        <div class="label">累计跑步</div>
      </div>
      <div class="item">
        <div class="value">{{stat.user_stat.duration}}<span class="unit">小时</span></div>
        <div class="label">总计时长</div>
      </div>
    </div>
    <div class="stat_panel bgwhite mb2" v-if="stat">
      <div class="item">
        <div class="value">{{stat.user_stat.avg_distance}}<span class="unit">公里</span></div>
        <div class="label">平均跑量</div>
      </div>
      <div class="item">
        <div class="value">{{stat.user_stat.avg_pace}}</div>
        <div class="label">平均配速</div>
      </div>
      <div class="item"></div>
    </div>

    <div class="stat_panel bgwhite mt2" v-if="stat">
      <div class="item" @click="gotoReviewRecord(0)">
        <div class="value">{{ stat.wait }}</div>
        <div class="label">未审核</div>
      </div>
      <div class="item" @click="gotoReviewRecord(1)">
        <div class="value">{{ stat.success }}</div>
        <div class="label">审核通过</div>
      </div>
      <div class="item" @click="gotoReviewRecord(2)">
        <div class="value">{{ stat.fail }}</div>
        <div class="label">审核不通过</div>
      </div>
    </div>

    <van-cell class="mt2" title="我的打卡记录" />
    <van-list
      class="bgwhite"
      v-model="loading"
      finished-text="没有更多了"
      :finished="finished"
      :immediate-check="true"
      @load="onLoad"
    >
      <record-panel
        class="bgwhite"
        v-for="(item, index) in list"
        :key="index"
        :record="item"
        :has-more="item.is_owner"
        :has-footer="false"
        @delete="onDelete"
      />
    </van-list>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Cell, Tab, Tabs, List, NavBar } from 'vant'
import RecordPanel from '@/views/record/components/RecordPanel'
import { myRecordStat, userRecordList } from '@/api/record'

export default {
  name: 'MyRecord',
  components: {
    [Cell.name]: Cell,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [List.name]: List,
    [NavBar.name]: NavBar,
    RecordPanel
  },
  data () {
    return {
      stat: null,
      list: [],
      loading: false,
      finished: false,
      listQuery: {
        user: '',
        status: 1,
        page: 0,
        size: 8
      }
    }
  },
  computed: {
    ...mapGetters([
      'userprofile'
    ])
  },
  created () {
    this.listQuery.user = this.userprofile.uuid
    this.getStat()
  },
  methods: {
    async getStat () {
      let response = await myRecordStat()
      this.stat = response.data
    },
    async getList () {
      this.loading = true
      let response = await userRecordList(this.listQuery)
      this.loading = false
      this.list = this.list.concat(response.data.results)
      this.checkFinished(response.data.count)
    },
    onLoad () {
      this.listQuery.page += 1
      this.getList()
    },
    checkFinished (total) {
      this.finished = this.list.length >= total
    },
    gotoReviewRecord (index) {
      this.$router.push('/my/review/record#' + index)
    },
    onDelete (record) {
      this.listQuery.page = 1
      this.list = []
      this.getList()
    },
    back () {
      this.$router.back()
    }
  }
}
</script>

<style scoped lang="scss">
.my_record {
  background-color: #f8f8f8;
  .stat_panel {
    height: 160px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .item {
      width: 200px;
      font-size: 28px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      .value {
        font-size: 38px;
      }
      .unit {
        font-size: 24px;
        margin-left: 5px;
      }
      .label {
        color: #9c9c9c;
        font-size: 26px;
      }
    }
  }
}
</style>
